class Timezone {
    constructor({ id, name } = {}) {
        this.id = id; // public property
        this.name = name; // public property
    }
}

export default Timezone;
